import { render, staticRenderFns } from "./AffiliateSalesReport.vue?vue&type=template&id=924cbe8a"
import script from "./AffiliateSalesReport.vue?vue&type=script&lang=js"
export * from "./AffiliateSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports